import { GetterTree } from 'vuex';
import { AppState } from '.';

export const appGetters: GetterTree<AppState, AppState> = {
  isCustomerGroupOrderHost: state => !!state.order.pendingGroupOrder && state.order.isGroupOrderHost,
  currentOrder: (state, getters) => (state.order.isGroupOrderParticipant || getters.isCustomerGroupOrderHost ? state.order.pendingGroupOrder : state.order.pendingOrder),
  isAPIMGuacModeActive: (state) => !!state.featureFlags.orderingStatus?.isGuacModeActive,
  isCustomerGuacMode: (state, getters) => (getters.isAPIMGuacModeActive && state.customer.profile?.isGuacMode) || false,
  cachedRestaurant:(state, getters) => state.order.cachedRestaurant,
  isActiveStudent: (state) => state.customer.profile?.student?.studentStatus?.toLowerCase() === 'active',
};
